import { selectEntitiesMatchesEntityStatus } from '../../../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { type StateType } from '../../../../states';
import { MatchEntityStatus } from '../../../../states/entities/matches';
import { type SelectorMaker, type Selector } from '../../../../types/selectors';
import { createResultEqualSelector } from '../../../../utils/reselect';
import { selectLineUpCompetitor } from '../LineUpRacer/LineUpRacer.selector';
import { type LineUpRacerSelectorProps } from '../LineUpRacer/LineUpRacer.selector';

type LineUpPitStopPropsType = {
  isEnded?: boolean;
  count?: number;
};

const makeLineUpPitStopPropsSelector: SelectorMaker<LineUpPitStopPropsType> = () => {
  const selectLineUpRacerPitStops: Selector<number> = (state: StateType, props: LineUpRacerSelectorProps = {}) => {
    const competitor = selectLineUpCompetitor(state, props);
    return competitor?.pitStops ?? 0;
  };

  return createResultEqualSelector(
    [selectLineUpRacerPitStops, selectEntitiesMatchesEntityStatus],
    (pitStops, matchStatus) => ({
      count: pitStops,
      isEnded: MatchEntityStatus.isEnded(matchStatus),
    }),
  );
};

export default makeLineUpPitStopPropsSelector;
